"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePickerState = exports["default"] = void 0;
var _react = require("react");
var _utils = require("./utils");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var usePickerState = exports.usePickerState = function usePickerState(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    format = _ref.format,
    _ref$autoApply = _ref.autoApply,
    autoApply = _ref$autoApply === void 0 ? false : _ref$autoApply,
    activePreset = _ref.activePreset,
    disabled = _ref.disabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = _slicedToArray(_useState3, 2),
    pickerValue = _useState4[0],
    setPickerValue = _useState4[1];
  var isDirty = (0, _react.useMemo)(function () {
    return value !== pickerValue;
  }, [value, pickerValue]);
  var open = (0, _react.useCallback)(function () {
    return !disabled ? setIsOpen(true) : null;
  }, [disabled]);
  var close = (0, _react.useCallback)(function () {
    return setIsOpen(false);
  }, []);
  var activePresetRef = (0, _react.useRef)(activePreset);
  (0, _react.useMemo)(function () {
    activePresetRef.current = activePreset;
  }, [activePreset]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    var validKeys = [' ', 'ArrowUp', 'ArrowDown',
    // The native select doesn't respond to enter on MacOS, but it's recommended by
    // https://www.w3.org/TR/wai-data-cy-practices/examples/listbox/listbox-collapsible.html
    'Enter'];
    if (validKeys.indexOf(event.key) !== -1) {
      event.preventDefault();
      setIsOpen(true);
    }
  }, [setIsOpen]);
  var applyValue = (0, _react.useCallback)(function (newValue) {
    var needClosePicker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    onChange(newValue, activePresetRef.current);
    if (needClosePicker) {
      setIsOpen(false);
    }
  }, [onChange]);
  var display = (0, _react.useMemo)(function () {
    return format(open ? pickerValue : value, activePresetRef.current) || '';
  }, [format, pickerValue, value, open]);
  var wrapperProps = (0, _react.useMemo)(function () {
    return {
      open: isOpen,
      onDismiss: close,
      onKeyDown: handleKeyDown
    };
  }, [isOpen, close]);
  var inputProps = (0, _react.useMemo)(function () {
    return {
      value: display,
      openPicker: open,
      open: isOpen
    };
  }, [display, open, isOpen]);
  var pickerProps = (0, _react.useMemo)(function () {
    return {
      activePreset: activePresetRef.current,
      value: pickerValue,
      onCancel: close,
      onApply: function onApply() {
        return applyValue(pickerValue, true);
      },
      onPresetSelect: function onPresetSelect(value, presetKey) {
        activePresetRef.current = presetKey;
        setPickerValue(value);
        applyValue(value, true);
      },
      onChange: function onChange(value, isFinish) {
        activePresetRef.current = null;
        setPickerValue(value);
        if (isFinish && autoApply) {
          applyValue(value, true);
        }
      },
      isDirty: isDirty
    };
  }, [close, isDirty, autoApply, applyValue, pickerValue]);
  (0, _react.useEffect)(function () {
    if (!isOpen && !(0, _utils.isEqual)(value, pickerValue === null || pickerValue === void 0 ? void 0 : pickerValue.value)) {
      activePresetRef.current = activePreset;
      setPickerValue(value);
    }
  }, [value, isOpen, pickerValue]);
  return {
    wrapperProps: wrapperProps,
    inputProps: inputProps,
    pickerProps: pickerProps
  };
};
var _default = exports["default"] = usePickerState;